exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/megamenu.js-WebpackMultiOutput";